/**
 * WordPress dependencies
 */
import { registerBlockType } from '@wordpress/blocks';

// Extensions
import './extensions/store'; // Seems unused
import './extensions/store/settings';
import './extensions/hooks';
import './extensions/ProGeneralNotice';
import './extensions/plugin-sidebar';
// import './extensions/button';
import './extensions/responsive-display-control';

import './extend/classname/index.js';
import './extend/spacing/index.js';
import './extend/entrace-animation';
import './extend/save-template';
import './extend/styles/index.js';

import * as container from './blocks/container';
import * as map from './blocks/map';
import * as team from './blocks/team';
import * as teamMember from './blocks/team/team-member';
// import * as countDown from './blocks/count-down';
import * as testimonials from './blocks/testimonials';
import * as testimonial from './blocks/testimonials/testimonial';
import * as service from './blocks/service';
import * as infoBox from './blocks/info-box';
import * as starRating from './blocks/star-rating';
import * as postCarousel from './blocks/post-carousel';
import * as postList from './blocks/post-list';
import * as sectionTitle from './blocks/section-title';
import * as galleryCarousel from './blocks/gallery-carousel';
import * as button from './blocks/button';
import * as buttons from './blocks/buttons';
import * as iconBlock from './blocks/icon';
import * as templatesButtons from './blocks/template-browser';
import * as slider from './blocks/slider';
import * as slideItem from './blocks/slide-item';
import * as contentToggleItem from './blocks/content-toggle-item';
import * as faqs from './blocks/faqs';

// WooCommerce
import * as wcProductList from './blocks/wc-product-list';

/**
 * Function to register an individual block.
 *
 * @param {Object} block The block to be registered.
 *
 */
const registerBlock = ( block ) => {
	if ( ! block ) {
		return;
	}

	const { category } = block;

	const { name, settings } = block;

	// if ( ! supportsCollections() && ! name.includes( 'gallery' ) ) {
	// 	category = 'coblocks';
	// }

	registerBlockType( name, {
		category,
		...settings,
	} );
};

/**
 * Function to register blocks provided by CoBlocks.
 */
export const registerCoBlocksBlocks = () => {
	[
		container,
		map,
		team,
		teamMember,
		testimonials,
		testimonial,
		service,
		infoBox,
		starRating,
		postCarousel,
		postList,
		sectionTitle,
		galleryCarousel,
		button,
		buttons,
		templatesButtons,
		iconBlock,
		slider,
		slideItem,
		contentToggleItem,
		faqs,
		wcProductList,
	].forEach( registerBlock );
};

registerCoBlocksBlocks();
